import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { BulkShowTagDocument } from './bulk.generated';

export const useBulkShowTag = (options: ApiOptions<typeof BulkShowTagDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(BulkShowTagDocument, {
    ...useNotifications(BulkShowTagDocument, {
      failure: t('api.show_tags.bulk_add_error'),
      success: (data) => {
        const count = data.bulkTag?.taggables.length ?? 0;
        return t('api.show_tags.bulk_add_success_plural', { count });
      },
    }),
    ...options,
  });
};
